<template>
  <PageHeader :showBreadcrumb="true" />
  <div class="container p-3 text-center">
      <!-- Display All Combined Exams -->
      <div class="row mb-2 g-3">
        <div class="col-lg-12 col-md-12">
          <FormSelectGroup
              label="Select Exam"
              inputId="combined-exam-input"
              :required="true"
              state
          >
            <template #default>
              <PvSelect
                  id="combined-exam-input"
                  v-model="selectedCombined"
                  :options="combinedExamOptions"
                  :optionLabel="formatExamLabel"
                  optionValue="examProductId"
                  placeholder="-- Select Entity • Exam • Product --"
                  filter
                  autoOptionFocus
                  @change="onChangeCombined"
              />
            </template>
          </FormSelectGroup>
        </div>
      </div>
    <!-- Documents Upload/Delete Section -->
    <div v-if="selectedCombined" class="row">
      <div class="col-lg-6 col-md-12">
        <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
          <MNFileUpload module-type="Quality Assurance File Uploads" label="Opening Documents" ref="openingDocuments" name="openingDocuments" accept="application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel.sheet.macroEnabled.12" url="/undefined" :examProduct="selectedCombined" :fileLimit="1000"/>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
          <MNFileUpload module-type="Quality Assurance File Uploads" label="Sample Files" ref="SampleFiles" name="SampleFiles" accept="application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel.sheet.macroEnabled.12" url="/undefined" :examProduct="selectedCombined" :fileLimit="1000"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageHeader from "@/components/common/PageHeader.vue";
import MNFileUpload from "@/components/common/MNFileUpload.vue";
import FormSelectGroup from "@/components/common/FormSelectGroup.vue";
import {useAppStore} from "@/stores/appStore.js";
import {computed, ref} from "vue";
import {useAuthStore} from "@/stores/authStore.js";
import {useForm} from "@/composables/form.js";
import { QualityAssuranceFileUploadsModel } from '@/models/QualityAssuranceFileUploadsModel';

const store = useAuthStore();
const appStore = useAppStore();
const selectedCombined = ref();

const openingDocuments = ref();
const SampleFiles = ref();

const formState = useForm(new QualityAssuranceFileUploadsModel());

const combinedExamOptions = computed(() => {
  return appStore.getAllEntityExamProductOptions();
});

const onChangeCombined = async ({ value }) => {
  if (!value) return;
  selectedCombined.value = value;
  formState.state.data.examProductId  = value;
  await clearUploaders();
};

const formatExamLabel = (option) => {
  if (!option) return '';
  return `(${option.entityName} • ${option.examType} • ${option.productName})`;
};

const clearUploaders = async () => {
  openingDocuments.value?.clear();
  SampleFiles.value?.clear();
};
</script>

<style scoped>

</style>